"use client";

import { useReplyStore } from "@/lib/state/reply-store";
import { CommentForm } from "./comment-form";

interface ReplyComposerProps {
	postId?: number;
	submissionId?: number;
	editorialSlug?: string;
	commentId?: number | null;
	show: boolean;
	onSuccess?: () => void;
	/** Stronger reply UI for post thread root only. */
	prominent?: boolean;
	/** Lock editor geometry on mobile (prevents iOS zoom + layout morph). */
	stableOnMobile?: boolean;
}

export function ReplyComposer({
	postId,
	submissionId,
	editorialSlug,
	commentId,
	show,
	onSuccess,
	prominent = false,
	stableOnMobile = false,
}: ReplyComposerProps) {
	const clearReply = useReplyStore((state) => state.clearReply);

	if (!show) {
		return null;
	}

	const handleSuccess = () => {
		clearReply();
		onSuccess?.();
	};

	return (
		<div
			data-reply-composer
			data-stable-on-mobile={stableOnMobile ? "" : undefined}
			className="w-full min-w-0 max-w-full"
		>
			<CommentForm
				postId={postId}
				submissionId={submissionId}
				editorialSlug={editorialSlug}
				parentId={commentId ?? undefined}
				onSuccess={handleSuccess}
				onCancel={clearReply}
				prominent={prominent}
				stableOnMobile={stableOnMobile}
			/>
		</div>
	);
}
